import { render, staticRenderFns } from "./Shops.vue?vue&type=template&id=ebc1cda0&scoped=true&"
import script from "./Shops.vue?vue&type=script&lang=js&"
export * from "./Shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc1cda0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebc1cda0')) {
      api.createRecord('ebc1cda0', component.options)
    } else {
      api.reload('ebc1cda0', component.options)
    }
    module.hot.accept("./Shops.vue?vue&type=template&id=ebc1cda0&scoped=true&", function () {
      api.rerender('ebc1cda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Shops/Shops.vue"
export default component.exports